import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%'
  },

  input: {
    paddingBottom: '0.5rem',

    '& input': {
      flex: '1',
      border: 'none',
      outline: 'none'
    }
  },

  row: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: '10px',
    borderBottom: '2px solid #F1F1F1',
    paddingBottom: '0.5rem',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',

    '&:focus-within': {
      borderBottomColor: 'black'
    },

    '& .input': {
      display: 'flex',
      alignItems: 'center'
    },

    '& .adorn': {
      marginRight: '10px'
    }
  },

  checkbox: {
    margin: '0',
    padding: '0'
  },

  note: {
    fontSize: theme.size.sm,
    color: theme.palette.textAlt
  }
}))

export default useStyles
